import { JSX, useState } from "react";
import { SelectField } from "@hatch-digital-nl/abs-storybook/legacy";
import { useAssociatedFieldId } from "../../../common/utils/useAssociatedFieldId";

interface Props {
    id: number;
    options: {
        label: string;
        value: string;
    }[];
    onChange: (newValue: { value: string; label: string }) => void;
    value: {
        value: string;
        label: string;
    };
    onInputChange: (inputValue: string) => void;
    inputValue: string;
    errorMessage: string;
    placeHolder: string;
    title: string;
}

export const SelectFieldComponent = (props: Props): JSX.Element => {
    const {
        id,
        onChange,
        value,
        onInputChange,
        inputValue,
        errorMessage,
        placeHolder,
        options,
        title,
    } = props;

    const [selectFieldError, setSelectFieldError] = useState<{
        [key: string]: string | null;
    }>({});
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-edit-certificate-modal__form-group"}>
            <label htmlFor={fieldId}>{title}</label>
            <div ref={fieldRef}>
                <SelectField
                    placeHolder={placeHolder}
                    options={options}
                    searchIcon={true}
                    required={true}
                    onChange={onChange}
                    value={value.value ? value : null}
                    onInputChange={onInputChange}
                    inputValue={inputValue}
                    onBlur={() => {
                        if (!value?.value && errorMessage) {
                            setSelectFieldError((prevErrors) => ({
                                ...prevErrors,
                                [id]: errorMessage,
                            }));
                            return;
                        }

                        setSelectFieldError((prevErrors) => ({
                            ...prevErrors,
                            [id]: null,
                        }));
                    }}
                    error={!!selectFieldError[id]}
                />
            </div>
            {selectFieldError[id] && (
                <p className={"c-error-message"}>{selectFieldError[id]}</p>
            )}
        </div>
    );
};
